import { ServerService } from './serverService';
import { DashboardService } from './dashboard.service';

interface Server {
  ref: string;
  name: string;
  ip: string;
  user: string;
  password: string;
  description: string;
  washpark?: string | { _id: string };
  isDeploying?: boolean;
}

export class SettingsDeploymentService {
  /**
   * Ermittelt die Server-Referenz für den aktuellen Account
   */
  static async getCurrentAccountServerRef(): Promise<string | null> {
    try {
      const dashboardData = await DashboardService.getDashboard();
      const servers: Server[] = await ServerService.getServers();
      
      // Finde den Server, der mit dem aktuellen Account verknüpft ist
      const accountServer = servers.find((server: Server) => 
        server.washpark === dashboardData.id || 
        (typeof server.washpark === 'object' && server.washpark?._id === dashboardData.id)
      );
      
      if (accountServer) {
        console.log(`Server gefunden für Account ${dashboardData.displayName}: ${accountServer.ref}`);
        return accountServer.ref;
      }
      
      console.warn(`Kein Server für Account ${dashboardData.displayName} gefunden`);
      return null;
    } catch (error) {
      console.error('Fehler beim Ermitteln des Account-Servers:', error);
      return null;
    }
  }
  
  /**
   * Löst das Deployment für den aktuellen Account aus
   */
  static async triggerDeployment(): Promise<{ success: boolean; message: string }> {
    try {
      const serverRef = await this.getCurrentAccountServerRef();
      
      if (!serverRef) {
        return {
          success: false,
          message: 'Kein Server für Ihren Account gefunden. Bitte wenden Sie sich an den Support.'
        };
      }
      
      console.log(`Starte Deployment für Server: ${serverRef}`);
      await ServerService.deployServer(serverRef);
      
      return {
        success: true,
        message: 'Deployment erfolgreich gestartet'
      };
    } catch (error: any) {
      console.error('Fehler beim Deployment:', error);
      return {
        success: false,
        message: error.message || 'Fehler beim Starten des Deployments'
      };
    }
  }
  
  /**
   * Prüft den Deployment-Status für den aktuellen Account
   */
  static async getDeploymentStatus(): Promise<{
    isDeploying: boolean;
    serverRef: string | null;
  }> {
    try {
      const serverRef = await this.getCurrentAccountServerRef();
      
      if (!serverRef) {
        return { isDeploying: false, serverRef: null };
      }
      
      const status = await ServerService.getDeploymentLogs(serverRef);
      return {
        isDeploying: status.isDeploying,
        serverRef
      };
    } catch (error) {
      console.error('Fehler beim Abrufen des Deployment-Status:', error);
      return { isDeploying: false, serverRef: null };
    }
  }
} 